import { render, staticRenderFns } from "./ColorUpdateModal.vue?vue&type=template&id=89c1a5be&scoped=true&"
import script from "./ColorUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ColorUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c1a5be",
  null
  
)

export default component.exports